import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { compose } from 'recompose';
import { Translate, I18n } from 'react-redux-i18n';

import { needsNoAuth } from './utils/authHoc';
import { auth as actionAuth } from '../actions/auth';
import { trackYandexGoal } from '../actions/utils';
import AuthLangSwitch from './AuthLangSwitch';

import '../styles/auth-page.scss';

/*
 *  Auth form page
 */

class Auth extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.login = this.login.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);

    this.state = {
      email: '',
      password: '',
      highlightInvalid: false,
      showPassword: false,
    };
  }

  login(e) {
    e.preventDefault();

    const { email, password } = this.state;
    if (!email || !password) {
      this.setState({ highlightInvalid: true });
      return true;
    }

    trackYandexGoal('auth');
    this.props.auth(email, password);
    return false;
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }

  togglePasswordVisibility() {
    this.setState(state => ({ showPassword: !state.showPassword }));
  }

  render() {
    const {
      email,
      password,
      highlightInvalid,
      showPassword,
    } = this.state;

    let emailClass = '';
    let emailMessage = '';
    if (!email && highlightInvalid) {
      emailClass = 'has-error';
      emailMessage = <Translate value="auth.requiredField" />;
    }

    let passwordClass = '';
    let passwordMessage = '';
    if (!password && highlightInvalid) {
      passwordClass = 'has-error';
      passwordMessage = <Translate value="auth.requiredField" />;
    }

    return (
      <div className="rts-auth">
        <form className="rts-auth__card" onSubmit={this.login}>
          <img
            className="rts-auth__logo"
            src="/rts-logo-v3.7207c58d.png"
            alt="Rocket Tech School"
          />

          <div className="rts-auth__fields">
            <div className={`rts-auth__field ${emailClass}`}>
              <input
                type="email"
                className="rts-auth__input"
                placeholder={I18n.t('placeholder.login')}
                autoComplete="email"
                value={email}
                onChange={this.handleEmailChange}
                test-id="auth-input-email"
              />
              {emailMessage && (
                <span className="rts-auth__error">{emailMessage}</span>
              )}
            </div>

            <div className={`rts-auth__field ${passwordClass}`}>
              <input
                type={showPassword ? 'text' : 'password'}
                className="rts-auth__input rts-auth__input--password"
                placeholder={I18n.t('placeholder.password')}
                autoComplete="current-password"
                value={password}
                onChange={this.handlePasswordChange}
                test-id="auth-input-password"
              />
              <button
                type="button"
                className="rts-auth__toggle-password"
                onClick={this.togglePasswordVisibility}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                <i
                  className={`fa fa-eye${showPassword ? '' : '-slash'}`}
                  aria-hidden="true"
                />
              </button>
              {passwordMessage && (
                <span className="rts-auth__error">{passwordMessage}</span>
              )}
            </div>
          </div>

          <button
            type="submit"
            className="rts-auth__submit"
            test-id="auth-button-login"
          >
            <Translate value="auth.login" />
          </button>

          <a
            href="/auth/rts"
            className="rts-auth__sso"
            test-id="auth-button-teacher-sso"
          >
            <Translate value="auth.loginTeacherRts" />
          </a>

          {this.props.location &&
            this.props.location.query &&
            this.props.location.query.rtsError && (
              <span className="rts-auth__error rts-auth__error--sso">
                <Translate
                  value={`auth.rtsError.${
                    ['generic', 'denied', 'config', 'expired'].includes(
                      this.props.location.query.rtsError
                    )
                      ? this.props.location.query.rtsError
                      : 'generic'
                  }`}
                />
              </span>
            )}

          <Link to="/i/reset" className="rts-auth__forgot">
            <Translate value="auth.reset.forgot" />
          </Link>

          <div className="rts-auth__register">
            <p className="rts-auth__register-text">
              <Translate value="auth.noAccount" />
            </p>
            <Link to="/i/register" className="rts-auth__register-btn">
              <Translate value="register.signup" />
            </Link>
          </div>
        </form>

        <AuthLangSwitch />
      </div>
    );
  }
}

Auth.propTypes = {
  auth: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { isFetching, user } = state.auth;
  return {
    isFetching,
    user,
  };
}

const mapDispatchToProps = dispatch => ({
  auth: (email, password) => dispatch(actionAuth(email, password)),
});

export default compose(
  needsNoAuth,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Auth);
